import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4 table-hover" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", null, "ID"),
    /*#__PURE__*/_createElementVNode("th", null, "Số phiếu"),
    /*#__PURE__*/_createElementVNode("th", null, "Tên kho"),
    /*#__PURE__*/_createElementVNode("th", null, "Người nhận hàng"),
    /*#__PURE__*/_createElementVNode("th", null, "Ngày tạo"),
    /*#__PURE__*/_createElementVNode("th", null, "Ngày cập nhật"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_4 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (r) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: r.id
          }, [
            _createElementVNode("td", null, _toDisplayString(r.id), 1),
            _createElementVNode("td", null, _toDisplayString(r.so_phieu), 1),
            _createElementVNode("td", null, _toDisplayString(r.kho?.ten_kho), 1),
            _createElementVNode("td", null, _toDisplayString(r.nguoi_nhan?.ho_va_ten), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(r.created_at).format("DD/MM/YYYY hh:mm")), 1),
            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(r.updated_at).format("DD/MM/YYYY hh:mm")), 1),
            _createElementVNode("td", null, [
              _createVNode(_component_router_link, {
                to: _ctx.receiptDetailUrl(r.id)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen044.svg" })
                  ])
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}